export function paginationScroll() {
    var pageLinks = document.querySelectorAll('.pagination a');
    pageLinks.forEach(function(link) {
        link.addEventListener('click', function(event) {
            if (this.getAttribute('href').indexOf('#') === -1) {
                return;
            }
            event.preventDefault();
            window.scrollTo({
                top: 0,
                behavior: 'smooth'
            });
        });
    });
}
